import React, { Component } from 'react';
import {ApiBaseUrl} from '../../constants';
import tail from 'tail.select/js/tail.select.min';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { trackPromise } from 'react-promise-tracker';
import {withSnackbar} from "react-simple-snackbar";

class SearchComponent extends Component{
    state = {
        startDate: false
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        trackPromise(
        fetch(ApiBaseUrl+"/consumer/filter_categories")
            .then(res => res.json())
            .then(
                (result) => {
                    let items = {};
                    result.data.categories.forEach(category => {
                        items[category._id] = {value: category.name, group: "Select a vendor"};
                    })

                    if(Object.keys(items).length) {
                        tail(".select-description", {
                            search: true,
                            descriptions: true,
                            multiSelectAll: true,
                            placeholder: "Select vendor",
                            height: 250,
                            multiContainer: ".tail-move-container",
                            items: items
                        })
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    handleDateChange = date => {
        this.setState({
            startDate: date
        });
    }

    render() {
        return (
            <div className="inner-categories choose-deals-outer p-l-0 p-r-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 mx-auto px-0">
                        <div className="search-box-outer">
                            <form autoComplete="off" action={`${process.env.PUBLIC_URL}/oneday/category-deals`}>
                                <div className="search-fields--each">
                                    <label htmlFor="" className="label-search green-color">I want to go out</label>
                                    <div className="date-icon calandar-position-0 date_block date_select_block new-picker w-100 mw-100">
                                        <i className="fa fa-calendar"></i>
                                    <DatePicker
                                        maxDate={new Date(new Date().getFullYear()+1, new Date().getMonth(), new Date().getDate())}
                                        showPopperArrow={false}
                                        selected={this.state.startDate}
                                        placeholderText="Date"
                                        onChange={this.handleDateChange}
                                        minDate={new Date()}
                                        name="date"
                                        dateFormat="dd-MM-yyyy"
                                    />
                                    </div>
                                </div>
                                <div className="search-fields--each">
                                    <label htmlFor="" className="label-search green-color">In</label>
                                    <input type="text" placeholder="Las Vegas" className="input-search" readOnly/>
                                </div>
                                <div className="search-fields--each">
                                    <label htmlFor="" className="label-search green-color">Select vendor</label>
                                    <select readOnly value={this.state.selectedCategories} className="select-description" name="categories" multiple>
                                    </select>
                                    <div className="tail-move-container"></div>
                                </div>
                                <div className="text-left text-md-center mt-3">
                                    <div className="btn-rowstack d-flex justify-content-end">
                                        <button
                                            className="entry-btn cancel-btn grad-on d-none d-lg-block next-btn box-btn-0" type="submit">Next
                                        </button>
                                        <button className="entry-btn grad-on d-lg-none" type="submit"><img src={`${process.env.PUBLIC_URL}/image/back_white.png`} alt=""/></button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withSnackbar(SearchComponent,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});